




















import {Component, Mixins, Prop} from 'vue-property-decorator';
import {StringFormatter} from '@schachermayer/sch-vuejs-commons/src/mixins';
import ApplicationBarStoreModule from '../../store/modules/applicationBar.module';
import {getModule} from 'vuex-module-decorators';

@Component
export default class BudgetExceededModal extends Mixins(StringFormatter) {
    @Prop(Boolean) show: boolean;

    applicationBarStore: ApplicationBarStoreModule = getModule(ApplicationBarStoreModule, this.$store);

    close() {
        this.$emit('closed');
    }

    get title() {
        return this.$tc('extranetSecurity.dialog.budgetCheck.title');
    }

    get okTitle() {
        return this.$tc('extranetSecurity.order.button');
    }

    get cancelTitle() {
        return this.$tc('cancel');
    }

    oneClickBuy() {
        this.$emit('oneClickBuy');
    }
}
